import { GroupActionModal, type GroupActionModalProps } from './GroupActionModal';

type DeleteGroupModalProps = Omit<GroupActionModalProps, 'mode' | 'onClose'> & {
    onCancel: () => void;
};

export const DeleteGroupModal = ({ onCancel, ...props }: DeleteGroupModalProps) => (
    <GroupActionModal
        {...props}
        mode={'delete'}
        onClose={onCancel}
    />
);
